<template>
  <div class="cbox-p14 table-main">
    <TableHeader :refTable="refTable" storageKey="hiddenColumns_experimentCenter" @onRefresh="getTableData()">
      <slot></slot>
    </TableHeader>

    <el-table ref="table" :data="tableData" border stripe height="100%" style="width: 100%" v-loading="tableLoading">
      <el-table-column label="序号" align="center" width="50">
        <template v-slot="{ $index }">
          <span>{{ (searchModel.pageNum - 1) * searchModel.pageSize + $index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column label="报告编号" width="160" align="center">
        <template v-slot="{ row }">
          <el-link type="primary" @click="handleProcess(row)">{{ row.reportCode }}</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="client" label="委托单位" min-width="150" align="center"></el-table-column>
      <el-table-column prop="sampleName" label="检测项目" min-width="150" align="center"></el-table-column>
      <el-table-column prop="sampleCnt" label="数量" align="center"></el-table-column>

      <el-table-column prop="testedTime" label="试验日期" align="center"></el-table-column>
      <el-table-column
        v-if="deliverState == -3"
        prop="flowReason"
        label="退回原因"
        align="center"
        min-width="100"
      ></el-table-column>

      <el-table-column prop="testedByName" label="检测人员" align="center"></el-table-column>

      <el-table-column
        v-if="deliverState == 0 || deliverState == 2 || deliverState == -3"
        label="操作"
        width="200"
        align="center"
      >
        <template v-slot="{ row }">
          <div v-if="deliverState != 2" class="link-wrap">
            <el-link type="primary" @click="handleDrawReport(row, 0)">编制报告</el-link>
            <el-link type="danger" @click="handleDrawReport(row, 1)">编制报告(不合格)</el-link>
          </div>
          <div v-if="deliverState != 2" class="link-wrap">
            <el-link type="primary" @click="handleEditDate(row)">编辑试验日期</el-link>
            <el-link type="warning" @click="handleFile(row)">附件</el-link>
            <el-link type="primary" @click="handleSubmit(row)">提交</el-link>
          </div>
          <div v-if="deliverState == 2" class="link-wrap">
            <el-link type="danger" @click="handleCancel(row, 0)">撤回到编制</el-link>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      :current-page="searchModel.pageNum"
      :page-size="searchModel.pageSize"
      background
      layout="total, prev, sizes ,pager, next, jumper"
      :total="dataTotal"
      @current-change="onCurrentChange"
      @size-change="onSizeChange"
    ></el-pagination>

    <!-- 提交选择审核人弹窗 -->
    <ReportSubmit :visible.sync="submitVisible" :activeInfo="activeRowInfo" @refresh="getTableData()" />
    <!-- 编辑试验日期 -->
    <DateEdit :visible.sync="editVisible" :activeInfo="activeRowInfo" @refresh="getTableData()" />
    <!-- 流程信息 -->
    <ProcessDialog :visible.sync="processVisible" :activeId="activeRowId" />
    <!-- 退回 -->
    <ReturenDialog :visible.sync="returnVisible" :activatedRow="activeRowInfo" @refreshData="getTableData()" />
    <!-- 上传附件 -->
    <FlowFile :visible.sync="fileVisible" :activeInfo="activeRowInfo" />
    <!-- 设备超期警告弹窗 -->
    <el-dialog title="提示" :visible.sync="deviceExpireVisible" custom-class="device-dialog" width="400px">
      <p>{{ deviceExpireMessage }}</p>
      <span slot="footer">
        <el-button type="primary" @click="confirmDeviceExpire">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getToken } from '@/utils/auth';
import debounce from 'lodash/debounce';

import TableHeader from '@/components/TableHeader';
import DateEdit from './DateEdit';
import ReportSubmit from './ReportSubmit';
import FlowFile from './FlowFile';
import ProcessDialog from '@/components/BusinessComponents/ProcessDialog';
import ReturenDialog from '@/components/BusinessComponents/ReturenDialog';

import { getMyFlowDeliverList, editFlowState } from '@/api/flow';
import { getSample } from '@/api/system';

export default {
  components: { TableHeader, DateEdit, ReportSubmit, ProcessDialog, ReturenDialog, FlowFile },
  props: {
    deliverState: {
      type: String,
      default: '0'
    }
  },
  data() {
    return {
      refTable: null,
      searchModel: {
        pageNum: 1,
        pageSize: 20,
        orderType: 2
      },
      dataTotal: 0,
      tableLoading: false,
      tableData: [],
      activeRowId: null,
      activeRowInfo: {},
      editVisible: false,
      processVisible: false,
      returnVisible: false,
      submitVisible: false,
      fileVisible: false,
      deviceExpireVisible: false,
      deviceExpireMessage: '',
      activeFt: null,
      debouncedDrawReport: null
    };
  },
  computed: {},
  methods: {
    setSearchModel(val) {
      this.searchModel = { ...this.searchModel, ...val };
      this.getTableData(true);
    },
    onCurrentChange(pageNum) {
      this.searchModel.pageNum = pageNum;
      this.getTableData();
    },
    onSizeChange(pageSize) {
      this.searchModel.pageNum = 1;
      this.searchModel.pageSize = pageSize;
      this.getTableData(true);
    },
    async getTableData(isFirstPage = false) {
      if (isFirstPage) this.searchModel.pageNum = 1;
      this.tableLoading = true;

      const startDate = this.searchModel?.dateRange?.[0] ?? null;
      const endDate = this.searchModel?.dateRange?.[1] ?? null;
      const startTime = startDate ? startDate + ' 00:00:00' : null;
      const endTime = endDate ? endDate + ' 23:59:59' : null;

      const { data } = await getMyFlowDeliverList({ ...this.searchModel, startTime, endTime, deliverState: this.deliverState });

      this.dataTotal = data.count;
      const tableData = data.list || [];
      this.tableData = tableData.map(item => {
        const basis = JSON.parse(item.basisJson);
        const testItem = basis.map(item => item.itemName);
        // 去重
        const uniqueTestItem = [...new Set(testItem)];

        item.testItemList = uniqueTestItem;
        item.basisList = basis || [];

        return item;
      });

      this.tableLoading = false;
    },
    async _handleDrawReport(row, ft) {
      if (!row.testedTime) {
        this.$message.warning('请先填写试验日期！');
        this.handleEditDate(row);
        return;
      }

      if (row.sampleId) {
        const { data } = await getSample({ id: row.sampleId });
        const deviceList = data?.deviceList || [];
        if (deviceList.length > 0) {
          const testedTime = new Date(row.testedTime);

          const expireDeviceList = deviceList.filter(item => {
            if (item.nxCheckTime) {
              const deviceNxCheckTime = new Date(item.nxCheckTime);
              return deviceNxCheckTime < testedTime;
            } else {
              return false;
            }
          });

          if (expireDeviceList.length > 0) {
            this.deviceExpireMessage = `该检测项目（${row.sampleName}）下的检测设备 ${expireDeviceList
              .map(item => `${item.devName}（${item.devCode}）`)
              .join('、')} 已超过使用期限，请勿填写该设备！`;
            this.activeRowInfo = row;
            this.activeFt = ft;
            this.deviceExpireVisible = true;
          } else {
            this.openReport(row, ft);
          }
        } else {
          this.openReport(row, ft);
        }
      } else {
        this.openReport(row, ft);
      }
    },
    handleDrawReport(row, ft) {
      this.debouncedDrawReport(row, ft);
    },
    confirmDeviceExpire() {
      this.deviceExpireVisible = false;
      this.openReport(this.activeRowInfo, this.activeFt);
    },
    openReport(row, ft) {
      const params = JSON.stringify({
        token: getToken(),
        wordType: 'report',
        entrustmentId: row.entrustmentId,
        ft
      });
      if (ft == 0) {
        // eslint-disable-next-line no-undef
        POBrowser.openWindow('pageOffice/report', 'width=1200px;height=800px;', params);
      } else {
        // eslint-disable-next-line no-undef
        POBrowser.openWindow('pageOffice/reportFail', 'width=1200px;height=800px;', params);
      }
    },
    // 提交审核
    handleSubmit(row) {
      if (!row.testedTime) {
        this.$message.warning('请先编制报告和试验日期！');
        return;
      }
      this.activeRowInfo = row;
      this.submitVisible = true;
    },
    // 撤回提交
    handleCancel(row) {
      this.$confirm('确定要撤回该报告吗？撤回后在编制中列表中可重新进行提交。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await editFlowState({
          entrustmentId: row.entrustmentId,
          state: 6
        });
        this.getTableData();
        this.$message.success('撤回成功！');
      });
    },
    handleFile(row) {
      this.activeRowInfo = row;
      this.fileVisible = true;
    },
    handleEditDate(row) {
      this.activeRowInfo = row;
      this.editVisible = true;
    },
    handleReturn(row) {
      this.activeRowInfo = row;
      this.returnVisible = true;
    },
    handleProcess(row) {
      this.activeRowId = row.mainId;
      this.processVisible = true;
    }
  },
  created() {
    this.debouncedDrawReport = debounce(
      (row, ft) => {
        this._handleDrawReport(row, ft);
      },
      1000,
      { leading: true, trailing: false }
    );
  },
  mounted() {
    this.refTable = this.$refs.table;
  },
  activated() {
    this.getTableData();
    this.$nextTick(() => {
      this.$refs.table.doLayout(); // 重置表格布局
    });
  }
};
</script>
<style lang="scss" scoped>
.link-wrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
::v-deep .device-dialog {
  .el-dialog__body {
    padding: 0 20px;
  }
}
</style>
